import React from 'react';
import FromServer from '../projects/FromServer';
import { Divider, Grid, Checkbox, Avatar, Button, Switch } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import LocalStorage from '../../providers/LocalStorage';
import DocumenteList from '../../commons/DocumenteList';
import Utils from '../../providers/Utils';
import AlertDialog from '../../commons/dialogs/AlertDialog';
import CustomAppBar from '../../commons/AppBar';
import wordIcon from '../../Pics/word_icon.png'
import pdfIcon from '../../Pics/pdf.png'
import NewUserDrepturi from '../../commons/dialogs/NewUserDrepturi';
import ProgramLucru from '../../commons/dialogs/ProgramLucru';
import OpenAddFisaPostului from '../../commons/dialogs/OpenAddFisaPostului';
import OpenAddCV from '../../commons/dialogs/OpenAddCV';
import avatar from '../../Pics/avatar.jpg'
import ProgramCompanie from './ProgramCompanie';
import AlertNew from '../../commons/dialogs/AlertNew';

export default class ManagementUtilizator extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            departamente: [],
            isOpenNewUser: false,
            angajatInfo: {
                adresa: "",
                cnp: "",
                cost_minut: '',
                email: "",
                firma: '',
                functie: "",
                id: 0,
                id_departament: 0,
                id_user: 0,
                nume: "",
                nume_departament: "",
                oras: "",
                poza: "",
                salariu: '',
                sef_departament: '',
                telefon: "",
            },
            isFirmaExterna: false,
            toUpdate: false,
            userSelectat: '0',
            verifyEmail: '',
            parola: '',
            repetParola: '',
            vParola: '',
            isOpenProgram: false,
            isFirmaExterna: false,
            valuta_optiuni: ['lei', '$', '€'],
            valuta: 'lei',
            isOpenAlert: false,
            isOpenFisa: false,
            isOpenCv: false,
            societate: {},
            limba: this.ls.GetUserPreferences().language,
            languages: this.u.languages,
            openProgramCompanie: false,
            programSelectat: -1,
            programCompanie: [],
            isOpenAlert:false

        }
    }

    //'Upload/DocTask'

    // adresaMedia/Proiecte/Docs

    // adresaMedia/Taskuri/Docs

    componentDidMount() {
        this.fromServer()
        this.getWindowDimentions()

        this.getProgramCompanie()
    }

    ls = new LocalStorage()
    u = new Utils()
    ws = new Ws()

    getProgramCompanie = async () => {

        let getProgram = await this.ws.customSelect('select * from program_lucru where isnull(este_template,0)=1 and isnull(sters,0)!=1', {
            p1: 1
        })

        if (getProgram.Succes) {

            let programCompanie = [...getProgram.Content]

            for (let i = 0, n = programCompanie.length; i < n; i++) {

                programCompanie[i].lu_start = this.u.transformTimeFromSql(programCompanie[i].lu_start)
                programCompanie[i].lu_end = this.u.transformTimeFromSql(programCompanie[i].lu_end)
                programCompanie[i].ma_start = this.u.transformTimeFromSql(programCompanie[i].ma_start)
                programCompanie[i].ma_end = this.u.transformTimeFromSql(programCompanie[i].ma_end)
                programCompanie[i].mi_start = this.u.transformTimeFromSql(programCompanie[i].mi_start)
                programCompanie[i].mi_end = this.u.transformTimeFromSql(programCompanie[i].mi_end)
                programCompanie[i].jo_start = this.u.transformTimeFromSql(programCompanie[i].jo_start)
                programCompanie[i].jo_end = this.u.transformTimeFromSql(programCompanie[i].jo_end)
                programCompanie[i].vi_start = this.u.transformTimeFromSql(programCompanie[i].vi_start)
                programCompanie[i].vi_end = this.u.transformTimeFromSql(programCompanie[i].vi_end)
                programCompanie[i].sa_start = this.u.transformTimeFromSql(programCompanie[i].sa_start)
                programCompanie[i].sa_end = this.u.transformTimeFromSql(programCompanie[i].sa_end)
                programCompanie[i].du_start = this.u.transformTimeFromSql(programCompanie[i].du_start)
                programCompanie[i].du_end = this.u.transformTimeFromSql(programCompanie[i].du_end)


                programCompanie[i].lu_pauza_start = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_start)
                programCompanie[i].lu_pauza_end = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_end)
                programCompanie[i].ma_pauza_start = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_start)
                programCompanie[i].ma_pauza_end = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_end)
                programCompanie[i].mi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_start)
                programCompanie[i].mi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_end)
                programCompanie[i].jo_pauza_start = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_start)
                programCompanie[i].jo_pauza_end = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_end)
                programCompanie[i].vi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_start)
                programCompanie[i].vi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_end)
                programCompanie[i].sa_pauza_start = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_start)
                programCompanie[i].sa_pauza_end = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_end)
                programCompanie[i].du_pauza_start = this.u.transformTimeFromSql(programCompanie[i].du_pauza_start)
                programCompanie[i].du_pauza_end = this.u.transformTimeFromSql(programCompanie[i].du_pauza_end)
            }


            console.log('programCompanie :>> ', programCompanie);
            this.setState({
                programCompanie: programCompanie,
                programSelectat: programCompanie.length > 0 ? programCompanie[0] : null

            })
        }
    }

    changeProgramAll = (ev) => {

        let val = ev.target.value

        let programe = [...this.state.programCompanie]

        let idx = programe.findIndex(i => Number(i.id) === Number(val))

        console.log('idx :>> ', idx);
        if (idx !== -1) {

            console.log('programe :>> ', programe[idx]);

            let angajatInfo = { ...this.state.angajatInfo }

            angajatInfo.lu_start = programe[idx].lu_start
            angajatInfo.lu_end = programe[idx].lu_end
            angajatInfo.ma_start = programe[idx].ma_start
            angajatInfo.ma_end = programe[idx].ma_end
            angajatInfo.mi_start = programe[idx].mi_start
            angajatInfo.mi_end = programe[idx].mi_end
            angajatInfo.jo_start = programe[idx].jo_start
            angajatInfo.jo_end = programe[idx].jo_end
            angajatInfo.vi_start = programe[idx].vi_start
            angajatInfo.vi_end = programe[idx].vi_end
            angajatInfo.sa_start = programe[idx].sa_start
            angajatInfo.sa_end = programe[idx].sa_end
            angajatInfo.du_start = programe[idx].du_start
            angajatInfo.du_end = programe[idx].du_end



            this.setState({
                angajatInfo: angajatInfo,
                programSelectat: val
            }, () => {
                this.saveProgram()
            })
        }

    }

    fromServer = async (a = null) => {
        let fs = new FromServer();

        let ls = new LocalStorage

        let ws = new Ws()

        // ct(`select d.id as id_linie, d.doar_citire, d.nivel_responsabil, d.drepturi_extinse, d.id_utilizator as id ,
        //                                      a.nume, a.poza, a.cost_minut, u.email, u.firma, dep.nume as nume_departament from proiecte_drepturi d left join useri u on d.id_utilizator = u.id
        //                                      left join angajati a on u.id = a.id_user 
        //                                      left join angajati_departamente ad on ad.id_angajat = a.id
        //                                      left join departamente dep on dep.id = ad.id_departament
        //                                      where d.id_proiect = @p1 and isnull(u.inactiv,0) != 1 and isnull(d.sters,0) != 1 order by isnull(d.nivel_responsabil,3) asc`, {


        let de = await ws.customSelect('select * from angajati_departamente', {
            p1: 1
        })

        console.log('de :>> ', de);

        let getSocietate = await ws.customSelect('select * from setari', {
            p1: 'soc_code'
        })

        console.log('getSocietate :>> ', getSocietate);

        if (getSocietate.Succes) {

            let _users = ws.customSelect(`select 
            a.id , dep.id as id_departament, u.id as id_user,
            l.parola, l.parolac, l.email as email_logator, l.id_user_bazadate_proprie,
            ad.sef_departament,a.cnp,a.adresa,a.telefon, u.token,
            a.nume, a.poza, a.cost_minut, a.functie,a.oras, a.salariu, a.doc_fisa_postului,a.cv, u.email, u.firma, u.is_admin, dep.nume as nume_departament  from  useri u
            left join angajati a on u.id = a.id_user 
            left join angajati_departamente ad on ad.id_angajat = a.id
            left join departamente dep on dep.id = ad.id_departament
            left join pm_logator.[dbo].useri l on u.id = l.id_user_bazadate_proprie 
            where u.id = @p1 and isnull(u.inactiv,0) != 1 and l.id_societate_client = @p2 and  isnull(ad.inactiv,0) != 1 order by a.nume asc`, {
                p1: ls.GetUserData().InfoUser.IdUser,
                p2: getSocietate.Content.length > 0 ? Number(getSocietate.Content[0].val) : 1
            })

            // let logator = await  ws.customSelect(`select * from pm_logator.[dbo].useri `, {p1:1})

            // console.log('logator :>> ', logator);

            // let angajati = await ws.customSelect('select * from angajati', {
            //     p1: 1
            // })

            // console.log('angajati :>> ', angajati);

            let departamente = ws.customSelect('select * from departamente where isnull(inactiv,0) != 1', {
                p1: 0
            })


            let programLucru = ws.customSelect('select * from program_lucru where 1 = @p1', {
                p1: 1
            })

            let [users, dep, p] = await Promise.all([_users, departamente, programLucru])



            console.log('users :', users);


            if (users.Succes && dep.Succes && p.Succes) {

                let time = new Utils()

                let program = [...p.Content]

                let listUsers = [...users.Content]


                for (let i = 0, n = listUsers.length; i < n; i++) {

                    let idx = program.findIndex(p => p.id_angajat === listUsers[i].id)
                    let idxDep = dep.Content.findIndex(dep => dep.id === listUsers[0].id_departament)

                    if (idxDep !== -1) {
                        listUsers[i]['departament_nume'] = dep.Content[idxDep].nume
                    } else {
                        listUsers[i]['departament_nume'] = 'Lipsa Departament'
                    }

                    listUsers[i].selectat = false
                    listUsers[i].lu_start = idx !== -1 ? time.transformTimeFromSql(program[idx].lu_start) : '00:00'
                    listUsers[i].lu_end = idx !== -1 ? time.transformTimeFromSql(program[idx].lu_end) : '18:00'
                    listUsers[i].ma_start = idx !== -1 ? time.transformTimeFromSql(program[idx].ma_start) : '00:00'
                    listUsers[i].ma_end = idx !== -1 ? time.transformTimeFromSql(program[idx].ma_end) : '18:00'
                    listUsers[i].mi_start = idx !== -1 ? time.transformTimeFromSql(program[idx].mi_start) : '00:00'
                    listUsers[i].mi_end = idx !== -1 ? time.transformTimeFromSql(program[idx].mi_end) : '18:00'
                    listUsers[i].jo_start = idx !== -1 ? time.transformTimeFromSql(program[idx].jo_start) : '00:00'
                    listUsers[i].jo_end = idx !== -1 ? time.transformTimeFromSql(program[idx].jo_end) : '18:00'
                    listUsers[i].vi_start = idx !== -1 ? time.transformTimeFromSql(program[idx].vi_start) : '00:00'
                    listUsers[i].vi_end = idx !== -1 ? time.transformTimeFromSql(program[idx].vi_end) : '18:00'
                    listUsers[i].sa_start = idx !== -1 ? time.transformTimeFromSql(program[idx].sa_start) : '00:00'
                    listUsers[i].sa_end = idx !== -1 ? time.transformTimeFromSql(program[idx].sa_end) : '18:00'
                    listUsers[i].du_start = idx !== -1 ? time.transformTimeFromSql(program[idx].du_start) : '00:00'
                    listUsers[i].du_end = idx !== -1 ? time.transformTimeFromSql(program[idx].du_end) : '18:00'
                }








                // if (a) {
                //     let angajat = { ...this.state.angajatInfo }

                //     let idx = listUsers.findIndex(i => i.id === a.id)

                //     if (idx !== -1) {
                //         let newAngajat = listUsers[idx]

                //         this.setState({ angajatInfo: newAngajat })
                //     }
                // }


                console.log('listUsers :>> ', listUsers);




                this.setState({
                    angajatInfo: listUsers.length > 0 ? listUsers[0] : this.state.angajatInfo,
                    departamente: dep.Content,
                    societate: getSocietate.Content[0]
                })

            }

        }





    }



    saveProgram = async () => {

        let ws = new Ws();

        let verifyProgram = await ws.customSelect('select count(*) as c from program_lucru where id_angajat = @p1', {
            p1: this.state.angajatInfo.id
        })

        let objToInsert = {
            lu_start: this.state.angajatInfo.lu_start,
            lu_end: this.state.angajatInfo.lu_end,
            ma_start: this.state.angajatInfo.ma_start,
            ma_end: this.state.angajatInfo.ma_end,
            mi_start: this.state.angajatInfo.mi_start,
            mi_end: this.state.angajatInfo.mi_end,
            jo_start: this.state.angajatInfo.jo_start,
            jo_end: this.state.angajatInfo.jo_end,
            vi_start: this.state.angajatInfo.vi_start,
            vi_end: this.state.angajatInfo.vi_end,
            sa_start: this.state.angajatInfo.sa_start,
            sa_end: this.state.angajatInfo.sa_end,
            du_start: this.state.angajatInfo.du_start,
            du_end: this.state.angajatInfo.du_end,
            id_angajat: this.state.angajatInfo.id

        }

        let objToUpdate = {
            lu_start: this.state.angajatInfo.lu_start,
            lu_end: this.state.angajatInfo.lu_end,
            ma_start: this.state.angajatInfo.ma_start,
            ma_end: this.state.angajatInfo.ma_end,
            mi_start: this.state.angajatInfo.mi_start,
            mi_end: this.state.angajatInfo.mi_end,
            jo_start: this.state.angajatInfo.jo_start,
            jo_end: this.state.angajatInfo.jo_end,
            vi_start: this.state.angajatInfo.vi_start,
            vi_end: this.state.angajatInfo.vi_end,
            sa_start: this.state.angajatInfo.sa_start,
            sa_end: this.state.angajatInfo.sa_end,
            du_start: this.state.angajatInfo.du_start,
            du_end: this.state.angajatInfo.du_end,

        }

        // console.log('objToInsert :', objToInsert);


        // console.log('verifyProgram :', verifyProgram);
        if (verifyProgram.Succes) {
            if (verifyProgram.Content[0].c === 0) {
                let insertProgram = await ws.insert('program_lucru', objToInsert)

                if (insertProgram.Succes) {
                    this.setState({ isOpenProgram: false })
                }
            } else {
                let updateProgram = await ws.update('program_lucru', objToUpdate, { id_angajat: this.state.angajatInfo.id })

                if (updateProgram.Succes) {
                    this.setState({ isOpenProgram: false })
                }
            }
        }
    }

    selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }

    uploadDoc = async (id, idProiect) => {
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/DocProiect', saveFile, idProiect);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.getDocumente()
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }
    }











    getWindowDimentions = () => {
        let windowWidth = window.innerWidth


        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        })

    }

    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }





    changeFirma = (ev) => {
        let angajat = { ...this.state.angajatInfo }

        if (ev.target.checked) {
            angajat.departament = ''
            this.setState({
                angajat: angajat,
                isFirmaExterna: ev.target.checked
            })
        } else {
            angajat.firma = ''
            this.setState({
                angajat: angajat,
                isFirmaExterna: ev.target.checked
            })
        }
    }

    selectUserIntern = (u) => {

        console.log('u :>> ', u);

        let user = { ...u }

        user.sef_departament = user.sef_departament === 1
        this.setState({
            angajatInfo: user,
            isOpenNewUser: true,
            toUpdate: true,
            isFirmaExterna: false,
        })
    }

    selectUserExtern = (u) => {

        console.log('u :>> ', u);

        let user = { ...u }
        user.sef_departament = user.sef_departament === 1
        this.setState({
            angajatInfo: user,
            isOpenNewUser: true,
            toUpdate: true,
            isFirmaExterna: true,
        })
    }


    changeManager = (ev) => {
        let manager = { ...this.state.angajatInfo }

        manager["sef_departament"] = ev.target.checked

        this.setState({ angajatInfo: manager })
    }

    openNewUser = async () => {



        let ws = new Ws();


        let objToInsert = {
            nume: 'Nume Angajat',
            email: '',
            telefon: ''
        }

        let insertUser = await ws.insert('useri', objToInsert)




        if (insertUser.Succes) {

            // console.log('insertUser :', insertUser);
            let iAngajat = await ws.insert('angajati', { nume: objToInsert.nume, id_categorie: 1, id_user: insertUser.Content[0].id })





            if (iAngajat.Succes) {
                // let iDep =await ws.insert('angajati_departamente',{id_angajat:iAngajat.Content[0].id,
                //                                             id_departament:d.id})



                let angajatInfo = {
                    adresa: "",
                    cnp: "",
                    cost_minut: '',
                    email: "",
                    firma: '',
                    functie: "",
                    id: iAngajat.Content[0].id,
                    id_departament: 0,
                    id_user: insertUser.Content[0].id,
                    nume: "",
                    nume_departament: "",
                    oras: "",
                    poza: "",
                    salariu: '',
                    sef_departament: '',
                    telefon: "",
                }
                this.setState({
                    angajatInfo: angajatInfo,
                    toUpdate: false,
                    isOpenNewUser: true
                })
            }

        }


    }



    closeNewUser = async () => {
        let ws = new Ws()

        let updateA = ws.update('angajati', { inactiv: 1 }, { id: this.state.angajatInfo.id })
        let updateAD = ws.update('angajati_departamente', { inactiv: 1 }, { id_angajat: this.state.angajatInfo.id, id_departament: this.state.angajatInfo.id_departament })
        let updateU = ws.update('useri', { inactiv: 1 }, { id: this.state.angajatInfo.id_user })
        let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 1 }, { id_user_bazadate_proprie: this.state.angajatInfo.id_user })

        let [a, ad, u, ulog] = await Promise.all([updateA, updateAD, updateU, updateULog])

        if (a.Succes && u.Succes && ulog.Succes) {
            this.setState({ isOpenNewUser: false })
        }

    }



    insertNewUser = async () => {
        let ws = new Ws();
        let u = new Utils();


        let verifyEmail = await ws.customSelect('select * from pm_logator.[dbo].useri where email = @p1 and id_user_bazadate_proprie != @p2 ', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        console.log('verifyEmail :>> ', verifyEmail);

        if (verifyEmail.Succes) {
            if (verifyEmail.Content.length === 0 && (this.state.parola === this.state.repetParola) && this.state.parola.length >= 5) {


                let objAngajat = {
                    id_categorie: 1,
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    telefon: this.state.angajatInfo.telefon || 0,
                    oras: this.state.angajatInfo.oras || '',
                    adresa: this.state.angajatInfo.adresa || '',
                    cnp: this.state.angajatInfo.cnp || 0,
                    salariu: this.state.angajatInfo.salariu || 0,
                    cost_minut: this.state.angajatInfo.cost_minut || 0,
                    functie: this.state.angajatInfo.functie || '',
                }

                let objUser = {
                    token: u.randomData(32),
                    nume: this.state.angajatInfo.nume,
                    email: this.state.angajatInfo.email,

                }

                if (this.state.isFirmaExterna) {
                    objUser['firma'] = this.state.angajatInfo.firma || ''
                }

                let getSocietate = await ws.customSelect('select * from setari where param_code = @p1', {
                    p1: 'soc_id'
                })

                if (getSocietate.Succes) {

                    let objNewUserLogator = {
                        token: objUser.token,
                        nume: this.state.angajatInfo.nume,
                        id_societate_client: getSocietate.Content[0].val,
                        email: this.state.angajatInfo.email,
                        parola: this.state.parola,
                        parolac: this.state.parola,
                        id_user_bazadate_proprie: this.state.angajatInfo.id_user,
                    }

                    let updateA = ws.update('angajati', objAngajat, { id: this.state.angajatInfo.id })
                    let updateU = ws.update('useri', objUser, { id: this.state.angajatInfo.id_user })

                    let iUserDrepturi = ws.insert('useri_drepturi', {
                        id_utilizator: this.state.angajatInfo.id_user,

                        profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',

                        acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                        can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                        sterge_proiecte: 0

                    })

                    let insertD = ws.insert('angajati_departamente', {
                        id_angajat: this.state.angajatInfo.id,
                        id_departament: this.state.angajatInfo.id_departament,
                        sef_departament: this.state.angajatInfo.sef_departament || ''
                    })
                    let insertNewUser = ws.insert('pm_logator.[dbo].useri', objNewUserLogator)


                    let [a, u, d, n, iU] = await Promise.all([updateA, updateU, insertD, insertNewUser, iUserDrepturi])

                    console.log('iU :>> ', iU);

                    if (a.Succes && u.Succes && d.Succes && n.Succes) {



                        this.setState({ isOpenNewUser: false }, () => {

                            this.fromServer()
                        })
                    }


                    // console.log('insertNewUser :', insertNewUser);

                }






            } else {
                this.setState({
                    verifyEmail: 'Emailul deja exista !',
                    vParola: this.state.parola.length < 5 ? 'Parola trebuie sa aiba minim 5 caractere !' : (this.state.parola === this.state.repetParola ? '' : 'Parolele nu coincid !')
                })
            }

        }
    }



    updateAngajatParola = async () => {
        let ws = new Ws();
        let u = new Utils();

        let verifyEmail = await ws.customSelect('select * from useri where email = @p1 and id != @p2 and isnull(inactiv,0) != 1', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        console.log('verifyEmail :>> ', verifyEmail);

        console.log('angajatInfo :>> ', this.state.angajatInfo);

        if (verifyEmail.Succes) {

            if (verifyEmail.Content.length === 0) {



                let objNewUserLogator = {
                    // email: this.state.angajatInfo.email,
                    parola: this.state.parola,
                    parolac: this.state.parola,

                }


                let updateNewUserL = await ws.update('pm_logator.[dbo].useri', objNewUserLogator, { id_user_bazadate_proprie: this.state.angajatInfo.id_user })




                if (updateNewUserL.Succes) {
                    this.setState({ isOpenNewUser: false }, () => {
                        this.fromServer()
                    })
                }
            } else {
                this.setState({
                    verifyEmail: 'Emailul deja exista !',
                    vParola: this.state.parola.length < 5 ? 'Parola trebuie sa aiba minim 5 caractere !' : (this.state.parola === this.state.repetParola ? '' : 'Parolele nu coincid !')
                })
            }


        }

    }

    updateAngajat = async () => {

        let ws = new Ws();
        let u = new Utils();

        let verifyEmail = await ws.customSelect('select * from pm_logator.[dbo].useri where email = @p1 and id_user_bazadate_proprie != @p2 ', {
            p1: this.state.angajatInfo.email,
            p2: this.state.angajatInfo.id_user
        })

        console.log('verifyEmail :>> ', verifyEmail);

        console.log('angajatInfo :>> ', this.state.angajatInfo);

        if (verifyEmail.Succes) {

            if (verifyEmail.Content.length === 0) {

                let objAngajat = {
                    id_categorie: 1,
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',
                    telefon: this.state.angajatInfo.telefon || 0,
                    oras: this.state.angajatInfo.oras || '',
                    adresa: this.state.angajatInfo.adresa || '',
                    cnp: this.state.angajatInfo.cnp || 0,
                    salariu: this.state.angajatInfo.salariu || 0,
                    cost_minut: this.state.angajatInfo.cost_minut || 0,
                    functie: this.state.angajatInfo.functie || '',

                }

                let objUser = {
                    nume: this.state.angajatInfo.nume || '',
                    email: this.state.angajatInfo.email || '',

                }

                let objNewUserLogator = {
                    email: this.state.angajatInfo.email,
                    // parola: this.state.parola,
                    // parolac: this.state.parola,

                }


                if (this.state.isFirmaExterna) {
                    objUser['firma'] = this.state.angajatInfo.firma || ''
                }



                let updateA = ws.update('angajati', objAngajat, { id: this.state.angajatInfo.id })
                let updateU = ws.update('useri', objUser, { id: this.state.angajatInfo.id_user })

                let selectDrepturi = await ws.customSelect('select * from useri_drepturi where id_utilizator = @p1', {
                    p1: this.state.angajatInfo.id_user
                })

                let iUserDrepturi

                if (selectDrepturi.Succes) {
                    if (selectDrepturi.Content.length > 0) {
                        console.log('are Drepturi  :>> ', selectDrepturi.Content);

                        iUserDrepturi = ws.update('useri_drepturi', {

                            profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',

                            acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            sterge_proiecte: 0

                        }, { id_utilizator: this.state.angajatInfo.id_user, })
                    } else {
                        iUserDrepturi = ws.insert('useri_drepturi', {
                            id_utilizator: this.state.angajatInfo.id_user,
                            profil_selectat: this.state.angajatInfo['sef_departament'] ? 'Manager' : 'Angajat',


                            acces_rapoarte: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_setari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            acces_utilizatori: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_extins_proiecte: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_evaluari: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            acces_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,
                            can_edit_monitorizare: this.state.angajatInfo['sef_departament'] ? 1 : 0,

                            sterge_proiecte: 0

                        })
                    }
                }

            




                let updateD = ws.update('angajati_departamente', {
                    id_departament: this.state.angajatInfo.id_departament || '',
                    sef_departament: this.state.angajatInfo.sef_departament || ''
                }, { id_angajat: this.state.angajatInfo.id })

                let updateNewUserL = ws.update('pm_logator.[dbo].useri', objNewUserLogator, { id_user_bazadate_proprie: this.state.angajatInfo.id_user, id_societate_client: Number(this.state.societate.val) })

                let [uA, uU, uD, iU, uL] = await Promise.all([updateA, updateU, updateD, iUserDrepturi, updateNewUserL])

                console.log('uA :>> ', uA);
                console.log('uU :>> ', uU);
                console.log('uD :>> ', uD);
                console.log('iU :>> ', iU);
                console.log('uL :>> ', uL);

                if (uA.Succes && uU.Succes && uD.Succes) {
                    this.setState({ isOpenNewUser: false,
                        isOpenAlert:true}, () => {
                        this.fromServer()
                    })
                }
            } else {
                this.setState({
                    verifyEmail: 'Emailul deja exista !',
                    vParola: this.state.parola.length < 5 ? 'Parola trebuie sa aiba minim 5 caractere !' : (this.state.parola === this.state.repetParola ? '' : 'Parolele nu coincid !')
                })
            }


        }
    }

    changeData = (ev) => {
        let angajat = { ...this.state.angajatInfo }

        angajat[ev.target.name] = ev.target.value

        this.setState({
            angajatInfo: angajat,
            verifyEmail: ''
        })
    }


    deleteUser = async (us) => {

        let ws = new Ws()

        let updateA = ws.update('angajati', { inactiv: 1 }, { id: us.id })
        let updateAD = ws.update('angajati_departamente', { inactiv: 1 }, { id_angajat: us.id, id_departament: us.id_departament })
        let updateU = ws.update('useri', { inactiv: 1 }, { id: us.id_user })
        let updateULog = ws.update('pm_logator.[dbo].useri', { inactiv: 1 }, { token:us.token })

        let [a, ad, u, ulog] = await Promise.all([updateA, updateAD, updateU, updateULog])

        if (a.Succes && u.Succes && ulog.Succes) {
            this.setState({ isOpenNewUser: false }, () => {

                this.fromServer()
            })
        }

    }


    changeProgram = nume => ev => {
        let oldState = { ...this.state.angajatInfo }

        oldState[nume] = ev.target.value

        console.log('ev.target.value :>> ', ev.target.value);
        console.log('nume :>> ', nume);

        this.setState({
            angajatInfo: oldState
        })
    }

    absent = (ev, zi) => {
        //    console.log('ev :', ev);

        //    console.log('zi :', zi);

        let oldState = { ...this.state.angajatInfo }

        if (oldState[zi] === '00:00') {
            oldState[zi] = '09:00'
        } else {
            oldState[zi] = '00:00'
        }
        this.setState({
            angajatInfo: oldState
        })
    }

    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }




    // -________------______----___----_----_---_-_--_-

    uploadPoza = async (id, idAngajat, bkId) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        let chPoza = document.getElementById(bkId)




        reader.onload = async () => {
            let fileContent = reader.result;
            chPoza.style.backgroundImage = ` url(${fileContent})`
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/PozaAngajat', saveFile, idAngajat);

            // let uploadDocument = await ws.uploadimage('Upload/DocumentAngajat' ,saveFile, idAngajat);

            // console.log('uploadDocument :>> ', uploadDocument);

            console.log('uploadImage :', uploadImage);
            // if (uploadImage.Succes) {




            // }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }


    selectFile = (id) => {

        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()

    }

    uploadFisaPostului = async (id, idAngajat) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);





        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/FisaPostuluiAngajat', saveFile, idAngajat);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.props.getData(this.state.angajatInfo)
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    uploadCV = async (id, idAngajat) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);





        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/CvAngajat', saveFile, idAngajat);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                this.props.getData(this.state.angajatInfo)

            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    openFisaPostului = () => {


        if (this.state.angajatInfo.doc_fisa_postului) {
            let adresaFisa = new Ws().adresaMedia + `/Angajati/FisePost/${this.state.angajatInfo.doc_fisa_postului}`

            window.open(adresaFisa)
        } else {
            this.setState({
                isOpenAlert: true,
                strAlertMesaj: 'Nu exista fisa postului !'
            })
        }

    }


    openCv = () => {

        if (this.state.angajatInfo.cv) {
            let adresaFisa = new Ws().adresaMedia + `/Angajati/Cv/${this.state.angajatInfo.cv}`

            window.open(adresaFisa)
        } else {
            this.setState({
                isOpenAlert: true,
                strAlertMesaj: 'Nu exista CV !'
            })
        }

    }


    updateLimba = async () => {
        console.log('this.state.limba :>> ', this.state.limba);
        await this.ls.SetUserPreferences('language', this.state.limba)


        document.location.reload();



    }

    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={' '} appBarButtons={this.buildAppBarButtons()} />

                {this.state.openProgramCompanie &&

                    <ProgramCompanie
                        open={this.state.openProgramCompanie}
                        dialogClose={() => { this.setState({ openProgramCompanie: false }) }}
                    />
                }

                <AlertNew
                    open={this.state.isOpenAlert}
                    dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                    title={this.dictionary.managementUtilizatori.dateSalvate}
                    limba={this.dictionary}
                    yesFunction={() => { this.setState({ isOpenAlert: false }) }}
                    noButtonDisplay={1}
                />

                <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.managementUtilizatori.contulMeu} </h1>
                    </Grid>

                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <div style={{ position: 'relative', textAlign: 'left', margin: '80px 0px 40px' }}>
                            <select
                                id='limba'
                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                className='add-project-input'
                                type="text"
                                margin="normal"
                                name='limba'
                                // disabled={this.state.tip_bilantDisabled !== 1 ? true : false}
                                value={this.state.limba}
                                onChange={(ev) => { this.setState({ limba: ev.target.value }) }}
                                // placeholder={this.dictionary.pontaje.tip_bilantCautaLucrator}
                                onBlur={this.updateLimba}
                            >




                                {this.state.languages.map((s, idx) => {
                                    return (
                                        <option key={idx} value={s.id}>{s.name}</option>
                                    )
                                })}


                            </select>
                            <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.home.limba}</label>
                        </div>
                    </Grid>




                </Grid>

                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, maxWidth: 1000, margin: 'auto' }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid style={{ width: '90%', margin: 'auto' }} container>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <div className='fix-line'></div>

                                <input type='file' id={`file${this.state.angajatInfo.id}`}
                                    style={{ display: 'none' }}
                                    accept='image/*'
                                    onChange={() => { this.uploadPoza(`file${this.state.angajatInfo.id}`, this.state.angajatInfo.id, 'angajat-upload-poza') }} />


                                <div
                                    id={'angajat-upload-poza'}
                                    onClick={() => { this.selectFile(`file${this.state.angajatInfo.id}`) }}
                                    className='pm-angajati-picture-update'
                                    style={{
                                        backgroundImage: `url('${this.state.angajatInfo.poza ? (new Ws().adresaMedia + '/Angajati/' + this.state.angajatInfo.poza) : avatar}')`,
                                    }}>

                                </div>
                            </Grid>


                        </Grid>
                        <Grid style={{ width: '90%', margin: 'auto', marginTop: 40 }} container >

                            <Grid item  xs={6} sm={6} md={6} lg={6} xl={6} >
                                <Grid style={{ padding: 5 }} container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 16, fontWeight: 500, color: 'black' }}>
                                            <span style={{ display: 'inline-flex' }}> {this.dictionary.managementUtilizatori.datePersonale} </span>

                                        </h4>
                                    </Grid>


                                    <Grid style={{ marginTop: 20, textAlign: 'left', position: 'relative' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <label className='inputLabelPM' htmlFor='nume'>{this.dictionary.managementUtilizatori.nume} </label>
                                        <input
                                            id='nume'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='nume'
                                            value={this.state.angajatInfo.nume || ''}
                                            onChange={this.changeData}
                                            placeholder={this.dictionary.managementUtilizatori.numeIntreg}
                                        />

                                    </Grid>

                                    <Grid item style={{ marginTop: 20, textAlign: 'left', position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >

                                        <label className='inputLabelPM' htmlFor='cnp'>{this.dictionary.managementUtilizatori.cnp} </label>
                                        <input
                                            id='cnp'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='cnp'
                                            placeholder={this.dictionary.managementUtilizatori.contulMeu}
                                            value={this.state.angajatInfo.cnp || ''}
                                            onChange={this.changeData}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, textAlign: 'left', position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='adresa'>{this.dictionary.managementUtilizatori.adresa} </label>
                                        <input
                                            id='adresa'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='adresa'
                                            placeholder={this.dictionary.managementUtilizatori.adresa}
                                            value={this.state.angajatInfo.adresa || ''}
                                            onChange={this.changeData}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, textAlign: 'left', position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='oras'>{this.dictionary.managementUtilizatori.oras} </label>
                                        <input
                                            id='oras'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='oras'
                                            placeholder={this.dictionary.managementUtilizatori.oras}
                                            value={this.state.angajatInfo.oras || ''}
                                            onChange={this.changeData}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, textAlign: 'left', position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.managementUtilizatori.telefon} </label>
                                        <input
                                            id='telefon'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='telefon'
                                            placeholder={this.dictionary.managementUtilizatori.telefon}
                                            value={this.state.angajatInfo.telefon || ''}
                                            onChange={this.changeData}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, textAlign: 'left', position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='email'>{this.dictionary.managementUtilizatori.email} </label>
                                        <input
                                            id='email'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='email'
                                            placeholder={this.dictionary.managementUtilizatori.adresaEmail}
                                            value={this.state.angajatInfo.email || ''}
                                            onChange={this.changeData}
                                        />

                                        {this.props.vEmail &&
                                            <span style={{
                                                fontSize: 12,
                                                color: 'red',
                                                paddingLeft: 6
                                            }}>{this.props.vEmail}</span>
                                        }

                                    </Grid>




                                </Grid>



                            </Grid>

                            <Grid item  xs={6} sm={6} md={6} lg={6} xl={6} >
                                <Grid style={{ padding: 5 }} container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 16, fontWeight: 500, color: 'black' }}>
                                            <span style={{ display: 'inline-flex', paddingLeft: 20 }}> {this.dictionary.managementUtilizatori.dateProfesionale} </span>

                                        </h4>
                                    </Grid>


                                    <Grid item style={{ display: !this.state.isFirmaExterna ? 'block' : 'none', marginTop: 20 }}  xs={12} sm={12} md={12} lg={12} xl={12} >

                                        <p className='read-only-managementUser'><span>{this.dictionary.managementUtilizatori.departament} : </span> <span style={{ fontWeight: 700 }}>{this.state.angajatInfo.nume_departament}</span></p>




                                    </Grid>
                                    <Grid item style={{ display: this.state.isFirmaExterna ? 'block' : 'none', marginTop: 20 }}  xs={12} sm={12} md={12} lg={12} xl={12} >


                                        <p className='read-only-managementUser'><span>{this.dictionary.managementUtilizatori.firma} : </span> <span style={{ fontWeight: 700 }}>{this.state.angajatInfo.firma}</span></p>





                                    </Grid>

                                    <Grid item style={{ marginTop: 20 }}  xs={12} sm={12} md={12} lg={12} xl={12} >

                                        <p className='read-only-managementUser'><span>{this.dictionary.managementUtilizatori.functie} : </span> <span style={{ fontWeight: 700 }}>{this.state.angajatInfo.functie}</span></p>


                                    </Grid>

                                    <Grid item style={{ marginTop: 20 }}  xs={12} sm={12} md={12} lg={12} xl={12} >

                                        <p className='read-only-managementUser'><span>{this.dictionary.managementUtilizatori.manager} : </span> <span style={{ fontWeight: 700 }}>{this.state.angajatInfo.sef_departament === 1 ? this.dictionary.managementUtilizatori.da : this.dictionary.managementUtilizatori.nu}</span></p>


                                    </Grid>


                                    <Grid item style={{ marginTop: 20 }}  xs={12} sm={12} md={12} lg={12} xl={12} >

                                        <p className='read-only-managementUser'><span>{this.dictionary.managementUtilizatori.salariu} : </span> <span style={{ fontWeight: 700 }}>{this.state.angajatInfo.salariu || 0} Lei</span></p>




                                    </Grid>

                                    <Grid item style={{ marginTop: 20 }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                    </Grid>
                                    <Grid item style={{ marginTop: 20 }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                    </Grid>

                                    <Grid style={{ textAlign: 'left', marginTop: 20, paddingLeft: 28 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <span onClick={() => this.setState({ isOpenProgram: true })} style={{ marginRight: 20, fontSize: 14, cursor: 'pointer' }}><i style={{ verticalAlign: 'middle' }} className='material-icons'>query_builder</i>{this.dictionary.managementUtilizatori.program}  </span>




                                    </Grid>

                                    {/* <Grid item style={{ textAlign: 'left', marginTop: 20, paddingLeft: 28 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <span onClick={() => this.setState({ isOpenFisa: true })} style={{ marginRight: 20, fontSize: 14, cursor: 'pointer' }}><i style={{ verticalAlign: 'middle' }} className='material-icons'>insert_drive_file</i> Fisa Postului</span>

                                        <input type='file' id={`fisa-postului-file`}
                                            style={{ display: 'none' }}
                                            accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                                            onChange={() => { this.uploadFisaPostului('fisa-postului-file', this.state.angajatInfo.id) }} />
                                    </Grid> */}

                                    {/* <Grid item style={{ textAlign: 'left', marginTop: 20, paddingLeft: 28 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <span onClick={() => { this.setState({ isOpenCv: true }) }} style={{ marginRight: 20, fontSize: 14, cursor: 'pointer' }}><i style={{ verticalAlign: 'middle' }} className='material-icons'>description</i> Curricullum Vitae</span>

                                        <input type='file' id={`CV-file`}
                                            style={{ display: 'none' }}
                                            accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                                            onChange={() => { this.uploadCV('CV-file', this.state.angajatInfo.id) }} />
                                    </Grid> */}






                                    {/* <Grid item style={{
                                        display: 'block'
                                        // !this.props.toUpdate ? 'block' : 'none'

                                        , marginTop: 20
                                    }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                        <input
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='repetParola'
                                            value={this.state.repetParola || ''}
                                            onChange={this.repetaParolaChange}
                                            placeholder='Repeta Parola'
                                        />



                                    </Grid> */}
                                </Grid>
                            </Grid>









                            <Grid style={{ marginTop: 20, textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Button
                                    style={{ backgroundColor: 'rgb(24 165 58 )', textTransform: 'unset', paddingLeft: 40, paddingRight: 40 }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => { this.updateAngajat() }}
                                >
                                    {this.dictionary.managementUtilizatori.salveaza}
                                </Button>




                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>


                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, maxWidth: 1000, margin: 'auto', marginTop: 20 }}>

                    <Grid style={{ width: '90%', margin: 'auto', marginTop: 40 }} container >

                        <Grid item  xs={6} sm={6} md={6} lg={6} xl={6} >
                            <Grid style={{ padding: 5 }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 16, fontWeight: 500, color: 'black' }}>
                                        <span style={{ display: 'inline-flex' }}> {this.dictionary.managementUtilizatori.securitate} </span>

                                    </h4>
                                </Grid>

                                <Grid item style={{
                                    display: 'block'
                                    // !this.props.toUpdate ? 'block' : 'none'

                                    , marginTop: 20
                                }}  xs={12} sm={12} md={12} lg={12} xl={12} >

                                    <input
                                        className='add-project-input'
                                        type="password"
                                        margin="normal"
                                        name='parola'
                                        value={this.state.parola || ''}
                                        onChange={(ev) => { this.setState({ parola: ev.target.value, repetParola: ev.target.value }) }}
                                        placeholder='Parola'
                                    />

                                    {this.state.vParola &&
                                        <span style={{
                                            fontSize: 12,
                                            color: 'red',
                                            paddingLeft: 6
                                        }}>{this.state.vParola}</span>
                                    }

                                </Grid>
                                <Grid style={{ marginTop: 20, textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <Button
                                        style={{ backgroundColor: 'rgb(24 165 58 )', textTransform: 'unset', paddingLeft: 40, paddingRight: 40 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => { this.updateAngajatParola() }}
                                    >
                                        {this.dictionary.managementUtilizatori.salveaza}
                                    </Button>




                                </Grid>

                            </Grid>

                        </Grid>

                        <Grid style={{ paddingLeft: 40 }} item  xs={6} sm={6} md={6} lg={6} xl={6} >
                            <Grid style={{ padding: 5 }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 16, fontWeight: 500, color: 'black' }}>
                                        <span style={{ display: 'inline-flex' }}> {this.dictionary.managementUtilizatori.info} </span>

                                    </h4>
                                </Grid>

                                <Grid item style={{
                                    display: 'block',
                                    // !this.props.toUpdate ? 'block' : 'none'
                                    textAlign: 'left',
                                    marginTop: 20
                                }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <span style={{ fontSize: 14 }}> {this.dictionary.managementUtilizatori.oParolaMaiPuternica} </span>
                                </Grid>

                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>




                <Grid style={{ marginTop: 20, marginBottom: 20, textAlign: 'center' }} container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <span style={{ color: 'gray', fontSize: 12, }}>Version:{this.ws.appVersion}</span>
                    </Grid>
                </Grid>






                {/* <NewUserDrepturi
                    open={this.state.isOpenNewUser}
                    dialogClose={this.state.toUpdate ? () => { this.setState({ isOpenNewUser: false }) } : this.closeNewUser}
                    angajat={this.state.angajatInfo}
                    departamente={this.state.listDepartamente}
                    isFirmaExterna={this.state.isFirmaExterna}
                    changeFirma={this.changeFirma}
                    changeData={(ev) => { this.changeData(ev) }}
                    limba={this.dictionary}
                    vEmail={this.state.verifyEmail}
                    updateAngajat={this.state.toUpdate ? this.updateAngajat : this.insertNewUser}
                    parola={this.state.parola}
                    repetParola={this.state.repetParola}
                    parolaChange={(ev) => { this.setState({ parola: ev.target.value }) }}
                    repetaParolaChange={(ev) => { this.setState({ repetParola: ev.target.value }) }}
                    vParola={this.state.vParola}
                    toUpdate={this.state.toUpdate}
                    changeManager={this.changeManager}
                    stergeAngajat={() => { this.deleteUser(this.state.angajatInfo) }}
                    getData={() => { this.fromServer(this.state.angajatInfo) }}
                    openProgram={() => { this.setState({ isOpenProgram: true }) }}
                /> */}


                <ProgramLucru
                    open={this.state.isOpenProgram}
                    dialogClose={() => { this.setState({ isOpenProgram: false }) }}
                    limba={this.dictionary}
                    angajat={this.state.angajatInfo}
                    changeProgram={this.changeProgram}
                    absent={this.absent}
                    salveazaProgram={this.saveProgram}
                    programSelectat={this.state.programSelectat}
                    changeProgramAll={this.changeProgramAll}
                    programCompanie={this.state.programCompanie}
                />

                {/* <OpenAddFisaPostului
                    open={this.state.isOpenFisa}
                    dialogClose={() => { this.setState({ isOpenFisa: false }) }}
                    selectFile={this.selectFile}
                    openFisaPostului={this.openFisaPostului}
                    limba={this.dictionary}
                    nuIntroduce={true}
                />



                <OpenAddCV
                    open={this.state.isOpenCv}
                    dialogClose={() => { this.setState({ isOpenCv: false }) }}
                    selectFile={this.selectFile}
                    openCV={this.openCv}
                    limba={this.dictionary}
                /> */}
                {/* <div
                    onClick={() => { this.selectFile('fileproiect') }}
                    className='container'>
                    <h1 className='pm-title'>{this.dictionary.proiecte.segmentButtons.documente}</h1>
                    <div style={{ position: this.state.fullScreen ? '' : 'absolute', top: 0, right: 30, cursor: 'pointer' }}>
                        <i style={{ display: 'block', fontSize: 40, color: '#6f9ce2' }} className='material-icons'>cloud_upload</i>
                        <span className='pm-title'>{this.dictionary.proiecte.informatiiProiect.upload}</span>

                        <input type='file' id={`fileproiect`}
                            style={{ display: 'none' }}
                            accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                            onChange={() => { this.uploadDoc(`fileproiect`, this.props.idproiect) }} />

                    </div>


                </div> */}

                {/* <Grid style={{ maxWidth: 500, margin: 'auto' }} container>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeProiect}
                                checked={this.state.proiecteCheck} />
                            Proiecte</h3>

                    </Grid>
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeEtape}
                                checked={this.state.etapeCheck} />
                            Etape</h3>

                    </Grid>

                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <h3 style={{ marginBottom: 3 }} className="pm-title">
                            <Checkbox style={{ color: '#000000', padding: 0 }}
                                onChange={this.changeTaskuri}
                                checked={this.state.taskuriCheck} />
                            Taskuri</h3>

                    </Grid>



                </Grid> */}

                {/* 
                <Divider className='pm-divider' />
                <DocumenteList
                    elemente={this.state.listFiltered}
                    dict={this.dictionary}
                    onlyColumns={{ nume: 'nume', data: 'cand_uploadat', doc_info: 'doc_info' }}
                    goToFile={this.goToFile}
                    deleteFile={this.deleteFile}
                />

                <AlertDialog
                    open={this.state.isOpenAlert}
                    dialogClose={() => { this.setState({ isOpenAlert: false }) }}
                    title={this.dictionary.alertDate.document}
                    limba={this.dictionary}
                    yesFunction={this.deleteDoc} /> */}

            </div >
        );
    }
}